module.exports = __webpack_public_path__ + "fa14f0f3816ffa5ffdc8be313afd9308.jpg";